import { readOnly } from '@ember/object/computed';
import { belongsTo, attr, hasMany } from '@ember-data/model';
import ShModel from './sh-model';

class StoryCode extends ShModel {
  @attr('string') body;
  @attr('boolean') hidden;
  @attr('boolean') adminOnly;
  @attr('boolean') deactivated;
  @attr('date') deletedAt;

  @belongsTo('company', { async: false }) company;
  @hasMany('companyTeam', { async: false }) companyTeams;

  // for use with the 'sh-chips-freetext' component
  @readOnly('body') name;

  isCostCode = false;
}

export default StoryCode;
